import { NamedDefinitionPage } from './NamedDefinitionPage';

export function ProductSubGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/productsubgroups"
      listRoute="/product-sub-groups"
      title="Alt Grup"
      subtitle="Alt grup kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Alt Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Alt Grup"
      exportName="urun-alt-gruplari"
      entityLabel="alt grup"
    />
  );
}
